//
// Card
//

'use strict';

// Cookies

var Cookies = (function() {

	// Variables

	var $modal = $("#modal-cookie-consent");


	// Methods

	function show($this) {
        var cookies = localStorage.getItem('moc_cookie_consent');

        if(! cookies) {
            $this.modal('show')
        }
	}

	function hide($this) {
		$this.modal('hide')
	}

	// Events

	if ($modal.length) {
		show($modal);

        $modal.on('hidden.bs.modal', function (e) {
            localStorage.setItem('moc_cookie_consent', 1);
        })
	}

})();
